export const moveToFocusedInboxText = "VAc";
export const moveToOtherInboxText = "WAc";
export const alwaysMoveToFocusedInboxText = "XAc";
export const alwaysMoveToOtherInboxText = "YAc";
export const moveToFolderMoveAllFrom = "ZAc";
export const moveToOtherDisabledDueToOverride = "_Ac";
export default {moveToFocusedInboxText,moveToOtherInboxText,alwaysMoveToFocusedInboxText,alwaysMoveToOtherInboxText,moveToFolderMoveAllFrom,moveToOtherDisabledDueToOverride};